<template>
  <v-row
    v-if="!homepage"
    class="list-filter-buttons"
  >

    <!-- LIST SORT options-->

    <v-col
      cols="4"
      class="py-0 overflow-hidden"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            float
            block
            tile
            class="elevation-0"
            v-on="on"
          >
            <v-icon>
              fa-sort-alpha-down
            </v-icon>
            {{ currentSortTitle }}
          </v-btn>
        </template>
        <v-list style="cursor: pointer;">
          <v-list-item @click="changeSort('sortOrder')">
            <v-list-item-title>{{ $t('sorteeri') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeSort('dayPrice')">
            <v-list-item-title>{{ $t('sorteeri_hind') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeSort('region')">
            <v-list-item-title>{{ $t('sorteeri_asukoht') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <!-- Open detailed search on mobile  -->

    <v-col
      v-if="isMobileView"
      cols="4"
      class="py-0"
      style="border-right: 1px solid #ddd;border-left: 1px solid #ddd;"
    >
      <v-btn
        class="elevation-0"
        float
        block
        tile
        @click="showFilters"
      >
        <v-icon>
          fa-filter
        </v-icon>
        {{ $i18n.t('filter') }}
      </v-btn>
    </v-col>

    <!-- FAVORITES on desktop -->

    <v-col
      v-if="isDesktopView"
      class="py-0"
    >
      <v-btn
        float
        block
        tile
        class="elevation-0"
        @click="goToFavorites"
      >
        <i
          :class="searchFilters.favorites === 1 ? 'fa fa-heart' : 'far fa-heart'"
          style="color: #E53935; position: relative; cursor: pointer;"
          v-tooltip.bottom-end="$t('saved_favorites')"
        />
        {{ $i18n.t('favourites') }}
      </v-btn>
    </v-col>

    <!-- REGION MENU/FILTER -->

    <v-col
      cols="4"
      class="py-0"
    >
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            float
            block
            tile
            class="elevation-0"
            v-on="on"
          >
            <v-icon>
              fa-map-marked-alt
            </v-icon>
            {{ regionFilterTitle }}
          </v-btn>
        </template>
        <v-list style="cursor: pointer;">
          <v-list-item
            @click="changeRegion({})"
          >
            <v-list-item-title>{{ capitalize($i18n.t('näita_kõik')) }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="(objectRegion, ori) in objectRegions.filter(objectRegion => !objectRegion.hidden)"
            :key="ori"
            @click="changeRegion(objectRegion)"
          >
            <v-list-item-title>{{ objectRegion.regionName }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import sharedMethods from '@/methods/sharedMethods'
import sharedComputed from '@/methods/sharedComputed'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ListTopFilters',

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    regionFilterTitle () {
      if (parseInt(this.searchFilters.region)) {
        return this.objectRegions.filter(region => region.id === this.searchFilters.region)[0].regionName
      }
      return this.$i18n.t('region_short')
    },

    currentSortTitle () {
      const byKey = {
        sortOrder: this.$i18n.t('sorteeri'),
        dayPrice: this.$i18n.t('sorteeri_hind'),
        region: this.$i18n.t('sorteeri_asukoht'),
      }
      return byKey[this.searchFilters.sortBy]
    },
  },

  methods: {
    ...sharedMethods,

    showFilters () {
      this.detailedSearch = true
      document.location.href = '#searchfilters'
    },

    changeRegion (region) {
      Vue.set(this.searchFilters, 'region', region.id)
      this.searchFormSubmit()
    },

    changeSort (condition) {
      Vue.set(this.searchFilters, 'sortBy', condition)
    },
  },
}
</script>
